var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',[_vm._v("  "),_vm._v("\n  "),_c('code',{class:_vm.classes.code,domProps:{"innerHTML":_vm._s(_vm.html)}}),_vm._v("\n")])}
var staticRenderFns = []

export { render, staticRenderFns }